import { Badge } from "@/components/ui/badge";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface SubscriptionColumnProps {
  userId: string;
}

export const SubscriptionColumn = ({ userId }: SubscriptionColumnProps) => {
  const { data: subscriptions } = useQuery({
    queryKey: ['subscriptions'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('subscriptions')
        .select('*');
      
      if (error) throw error;
      return data;
    }
  });

  const getUserSubscription = (userId: string) => {
    const subscription = subscriptions?.find(sub => sub.owner_id === userId);
    return subscription?.plan || 'free';
  };

  const plan = getUserSubscription(userId);

  return (
    <Badge variant={plan === 'free' ? 'default' : 'secondary'}>
      {plan}
    </Badge>
  );
};